import { register } from 'tmr/tmr/ngModuleRegistry'

import './errors'

import * as apiAuth from './apiAuth'
import * as apiAuthInterceptor from './apiAuthInterceptor'
import * as appConfiguration from './appConfiguration'
import * as capabilities from './capabilities'
import * as deviceManager from './deviceManager'
import * as epc from './epc'
import * as error from './error'
import * as file from './file'
import * as infiniteScrollResources from './infiniteScrollResources'
import * as language from './language'
import * as operationHelper from './operationHelper'
import * as pageTitle from './pageTitle'
import * as print from './print'
import * as resource from './resource'
import * as resourceResolve from './resourceResolve'
import * as searchFormFilter from './searchFormFilter'
import * as searchFormFilters from './searchFormFilters'
import * as serialQ from './serialQ'
import * as shippingOperationsAccessControl from './accessControl/shippingOperations'
import * as shippingOperationsAccessControlLegacy from './accessControl/shippingOperationsLegacy'
import * as toast from './toast/toast'
import * as toastController from './toast/toast.controller'
import * as transformResourceAction from './transformResourceAction'
import * as translate from './translate'
import * as webSocket from './webSocket'

export default register(
  'tmr.core.services',
  apiAuth,
  apiAuthInterceptor,
  appConfiguration,
  capabilities,
  deviceManager,
  epc,
  error,
  file,
  infiniteScrollResources,
  language,
  operationHelper,
  pageTitle,
  print,
  resource,
  resourceResolve,
  searchFormFilter,
  searchFormFilters,
  serialQ,
  shippingOperationsAccessControl,
  shippingOperationsAccessControlLegacy,
  toast,
  toastController,
  transformResourceAction,
  translate,
  webSocket
)
